<template></template>

<script>
import Vuex from 'vuex'

import Storage from '../helpers/storage'
import Env from '../modules/env'

import {configuration} from '../../configuration'

export default {

    name: 'metas',

    computed: {

        ...Vuex.mapGetters([
            'lang',
            'page'
        ])
    },

    // update metas when page or lang are updated
    watch: {

        lang: function () {
            this.updateMetas()
        },

        page: function () {
            this.updateMetas()
        }

    },

    data() {
        return {
            metas: {}
        }
    },

    mounted() {
        this.initMetas()
        this.updateMetas()
    },

    methods: {

        initMetas() {

            this.$http.get('/meta.json')
                .then(response => {
                    this.metas = response.body
                    this.updateMetas()
                })
                .catch(() => {
                    if (Env.isLocal()) {
                        console.debug('no meta for local')
                    }
                })


        },

        updateMetas() {
            // only if metas have already been loaded
            if (Object.keys(this.metas).length) {

                const url = this.getUrl()
                const keywordsNotExist = !document.querySelector('meta[name="keywords"]')

                // if titleNotExist
                if (!document.querySelector('title')) {
                    const title = document.createElement('title')
                    document.getElementsByTagName('head')[0].appendChild(title)
                }
                // if no facebook meta title
                if (!document.querySelector('meta[name="meta-fb-title"]')) {
                    const titleFacebook = document.createElement('meta')
                    titleFacebook.name = 'meta-fb-title'
                    titleFacebook.property = 'og:title'
                    titleFacebook.id = 'meta-fb-title'
                    document.getElementsByTagName('head')[0].appendChild(titleFacebook)
                }
                // if no twitter meta title
                if (!document.querySelector('meta[name="meta-tw-title"]')) {
                    const titleTwitter = document.createElement('meta')
                    titleTwitter.name = 'meta-tw-title'
                    titleTwitter.property = 'twitter:title'
                    titleTwitter.id = 'meta-tw-title'
                    document.getElementsByTagName('head')[0].appendChild(titleTwitter)
                }
                // if no meta description
                if (!document.querySelector('meta[name="description"]')) {
                    const meta = document.createElement('meta')
                    meta.name = 'description'
                    document.getElementsByTagName('head')[0].appendChild(meta)
                }
                // if no facebook meta description
                if (!document.querySelector('meta[name="meta-fb-desc"]')) {
                    const metaFbDesc = document.createElement('meta')
                    metaFbDesc.name = 'meta-fb-desc'
                    metaFbDesc.property = 'og:description'
                    metaFbDesc.id = 'meta-fb-desc'
                    document.getElementsByTagName('head')[0].appendChild(metaFbDesc)
                }
                // if no twitter meta description
                if (!document.querySelector('meta[name="meta-tw-desc"]')) {
                    const metaTwDesc = document.createElement('meta')
                    metaTwDesc.name = 'meta-tw-desc'
                    metaTwDesc.property = 'twitter:description'
                    metaTwDesc.id = 'meta-tw-desc'
                    document.getElementsByTagName('head')[0].appendChild(metaTwDesc)
                }

                if (keywordsNotExist) {
                    const meta = document.createElement('meta')
                    meta.name = 'keywords'
                    document.getElementsByTagName('head')[0].appendChild(meta)
                }
                // always title before meta description
                const titleText = this.getTitle(url, this.lang)
                document.querySelector('title').text = titleText
                document.querySelector('meta[name="meta-fb-title"]').content = titleText
                document.querySelector('meta[name="meta-tw-title"]').content = titleText

                // content beetween 70 and 160 characters
                const descriptionText = this.getDescription(url, this.lang)
                document.querySelector('meta[name="description"]').content = descriptionText
                document.querySelector('meta[name="meta-fb-desc"]').content = descriptionText
                document.querySelector('meta[name="meta-tw-desc"]').content = descriptionText
                // keywords
                const keywords = this.getKeywords(url, this.lang)
                document.querySelector('meta[name="keywords"]').content = keywords


                if (Storage.getItem('debugMeta')) {
                    this.debugMeta(url)
                }
            }
        },


        getTitle(url, lang) {
            const title = this.metas[url] && this.metas[url].title && (this.metas[url].title[lang] || this.metas[url].title[configuration.defaultMetaLanguage])
            return title ? title : ''
        },

        getDescription(url, lang) {
            const description = this.metas[url] && this.metas[url].description && (this.metas[url].description[lang] || this.metas[url].description[configuration.defaultMetaLanguage])
            return description ? description : ''
        },

        getKeywords(url, lang) {
            const keywords = this.metas[url] && this.metas[url].keywords && (this.metas[url].keywords[lang] || this.metas[url].keywords[configuration.defaultMetaLanguage])
            return keywords ? keywords : ''
        },

        getUrl() {
            // remove language from url
            let url = document.location.pathname
            const secondNode = url.split('/')[1]

            if (configuration.languages.all.indexOf(secondNode) > -1) {
                url = url.split(secondNode)[1]
            }
            if(url === '') {
                url = '/'
            }
            return url
        },

        debugMeta() {

            const title = document.querySelector('title').text
            const metaDescription = document.querySelector('meta[name="description"]').content
            const keywords = document.querySelector('meta[name="keywords"]').content

            console.debug('title: ', title)
            console.debug('metaDescription: ', metaDescription)
            console.debug('keywords: ', keywords)
        }

    }

}

</script>
